let html = `<div class="scroll">
    <div class="scroll__content">
        <div class="scroll__body">
            
        </div>
    </div>
</div>`

export default html